module.exports = __webpack_public_path__ + "static/media/editPen.5e7b8ed9.svg";